import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-detail-advertising',
  templateUrl: './detail-advertising.component.html',
  styleUrls: ['./detail-advertising.component.scss']
})
export class DetailAdvertisingComponent {
  constructor(
    public dialogRef: MatDialogRef<DetailAdvertisingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { nameGroup: string }
  ) { }
  ngOnInit(): void { }

  public close(value: boolean): void {
    this.dialogRef.close(value);
  }
}
